import React, { Component } from "react";
import UserForm from "./components/UserForm";
import "bootstrap/dist/css/bootstrap.css";
import "react-datepicker/dist/react-datepicker.css";
import { ProgressBar, Container } from "react-bootstrap";
import "./App.css";
import Footer from "./components/Footer";

export class App extends Component {
  state = {
    progress: 16.68
  };

  done = value => {
    this.setState({
      done: value
    });
  };

  changeProgress = value => {
    this.setState({
      progress: value
    });
  };

  render() {
    return (
      <div className="App">
        <React.Fragment>
          <ProgressBar now={this.state.progress} variant={this.state.progress >= 100 ? "success" : ""} />
          {this.state.progress >= 100 && (
            <span className="float-right" id="closing-caption">
              <small>closing in 10 seconds...</small>
            </span>
          )}
        </React.Fragment>
        <Container>
          <UserForm changeProgress={this.changeProgress} />
        </Container>
        <Footer />
      </div>
    );
  }
}

export default App;
